// extracted by mini-css-extract-plugin
export default {"header":"BookHeader_header__I834B","name":"BookHeader_name__mQMcD","tagline":"BookHeader_tagline__nD9mc","accentLine":"BookHeader_accentLine__jsuy+"};